module.exports = "/images/vendor/flag-icon-css/flags/4x3/rs.svg?291d0fb654f2738012dabe35f370a1cd";